import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Label } from "@/components/ui/label";

interface NewPasswordFormProps {
  handleNewPassword: (e: React.FormEvent) => void;
  handleBackToLogin: () => void;
  isLoading: boolean;
  error: string | null;
  newPassword: string;
  setNewPassword: (value: string) => void;
  confirmPassword: string;
  setConfirmPassword: (value: string) => void;
}

export function NewPasswordForm({
  handleNewPassword,
  handleBackToLogin,
  isLoading,
  error,
  newPassword,
  setNewPassword,
  confirmPassword,
  setConfirmPassword,
}: NewPasswordFormProps) {
  return (
    <Card className="w-full">
      <CardHeader>
        <CardTitle>Initial Password Change</CardTitle>
        <CardDescription>
          You need to set a new password for your account
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleNewPassword} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="newPassword">New Password</Label>
            <Input
              id="newPassword"
              type="password"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required
              minLength={8}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="confirmPassword">Confirm Password</Label>
            <Input
              id="confirmPassword"
              type="password"
              placeholder="Confirm new password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
              minLength={8}
            />
          </div>
          {error && <p className="text-sm text-red-500">{error}</p>}
          <div className="flex gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={handleBackToLogin}
              className="flex-1"
              disabled={isLoading}
            >
              Back
            </Button>
            <Button
              type="submit"
              className="flex-1"
              disabled={isLoading || !newPassword || !confirmPassword}
            >
              {isLoading ? "Changing password..." : "Change Password"}
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
}
